import React, { useEffect } from 'react';
import './Home.scss';
import { Link, useHistory } from 'react-router-dom';
import { getLanguage, setLanguage, t, translate } from 'react-switch-lang';
import { useDispatch } from 'react-redux';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// eslint-disable-next-line import/no-unresolved
import { faChevronDown, faGlobeAmericas } from '@awesome.me/kit-299dd46f46/icons/classic/regular';
import paymentSource from '../../images/paymentsourcelogo_colour-1.png';
import { brandConfig, getAccessibilityName, getHomePageLogoStyle, languageText } from '../../configurations/Brands';
import { isDevelopment } from '../../helperFunctions/config';
import { actionSetLanguage } from '../../redux/Action';

// IMAGE RATIOS ARE 1.67

function languageToFull() {
  return languageText[getLanguage()];
}

function LangBtn({ lang, onSelect, children, ...props }) {
  const history = useHistory();
  return (
    <Dropdown.Item
      {...props}
      onClick={() => {
        history.push(`/home/${lang}`);
      }}
      aria-label={t('Language_Switch_To', null, lang)}
      lang={lang}
    >
      {children}
    </Dropdown.Item>
  );
}

function LanguageDropdown() {
  return (
    <Dropdown className="dropdownLanguage">
      <Dropdown.Toggle id="dropbtn">
        <div className="dropdownDisplay">
          <FontAwesomeIcon icon={faGlobeAmericas} />
          <span className="curLang">{languageToFull()}</span>
          <FontAwesomeIcon icon={faChevronDown} size="xs" className="dropDownIcon" />
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropDownMenu">
        <LangBtn lang="en">English</LangBtn>
        <LangBtn lang="fr" style={{ marginTop: '5px' }}>
          Français
        </LangBtn>
      </Dropdown.Menu>
    </Dropdown>
  );
}

function Home({ match: { params: { lang } } }) {
  const dispatch = useDispatch();

  useEffect(() => {
    setLanguage(lang);
    dispatch(actionSetLanguage(lang));
  }, [lang]);

  function renderDesktopBrands() {
    const slitBrands = Object.keys(brandConfig).reduce((rows, key, index) => (
      (index % 2 === 0 ?
        rows.push([key]) :
        rows[rows.length - 1].push(key)) && rows
    ), []);

    return slitBrands.map((row) => (
      <tr key={row}>
        {row.map((key) => (
          <td key={key} className="home-table">
            <div className="home-card-style mx-auto card">
              <Link
                className="brand-card-body"
                // If the lang is not supported by the brand, it will fall back to english.
                to={`/${brandConfig[key].homePage.link.replace('/en/', `/${lang}/`)}`}
                title={getAccessibilityName(key)}
              >
                <img
                  className="card-img"
                  src={brandConfig[key].homePage.imageDesktop}
                  alt={getAccessibilityName(key, lang)}
                  style={getHomePageLogoStyle(key)}
                />
                {!!brandConfig[key].homePage.cardTitleKey && (
                  <p className="brand-card-title">
                    {t(brandConfig[key].homePage.cardTitleKey)}
                  </p>
                )}
              </Link>
            </div>
          </td>
        ))}
      </tr>
    ));
  }

  function renderMobileBrands() {
    return Object.keys(brandConfig).map((key) => (
      <div key={key} className="home-card-style mx-auto card">
        <Link
          className="card-body"
          // If the lang is not supported by the brand, it will fall back to english.
          to={`/${brandConfig[key].homePage.link.replace('/en/', `/${lang}/`)}`}
        >
          <img
            className="card-img"
            src={brandConfig[key].homePage.imageMobile}
            alt={getAccessibilityName(key, lang)}
          />
          {!!brandConfig[key].homePage.cardTitleKey && (
            // Alt tags on the images are enough to describe the cards.
            <p className="brand-card-title" aria-hidden="true">
              {t(brandConfig[key].homePage.cardTitleKey)}
            </p>
          )}
        </Link>
      </div>
    ));
  }

  function createWidget(e) {
    let link;
    // eslint-disable-next-line default-case
    switch (e.currentTarget.getAttribute('data-value')) {
      case 'regular':
        link = document.getElementById('create-regular-widget-textbox').value;
        break;
      case 'category':
        link = document.getElementById('create-category-widget-textbox').value;
        break;
      case 'section':
        link = document.getElementById('create-section-widget-textbox').value;
        break;
      case 'mobileapp':
        link = document.getElementById('create-mobileapp-widget-textbox').value;
        break;
    }

    const widgetScript = document.createElement('script');
    widgetScript.setAttribute('src', `${window.location.origin}/WidgetJS.js`);
    widgetScript.setAttribute('link', link);
    document.body.appendChild(widgetScript);

    // hide debug menu
    document.getElementById('widget-debug-menu').style.display = 'none';
  }

  function showWidgetDebug() {
    if (isDevelopment()) {
      return (
        <>
          <hr />
          <p className="widget-test-title">Widget Test Mode</p>
          <p>Please refresh this page to remove widget button.</p>
          <div className="debug-widget">
            <input
              className="widget-debug-input"
              id="create-regular-widget-textbox"
              defaultValue={`${window.location.origin}/widget`}
            />
            <button id="create-widget-button" type="button" data-value="regular" onClick={createWidget}>Regular</button>
          </div>
          <div className="debug-widget">
            <input
              className="widget-debug-input"
              id="create-category-widget-textbox"
              defaultValue={`${window.location.origin}/widget/paysimply/en/category/825`}
            />
            <button id="create-widget-button" type="button" data-value="category" onClick={createWidget}>
              Category
            </button>
          </div>
          <div className="debug-widget">
            <input
              className="widget-debug-input"
              id="create-section-widget-textbox"
              defaultValue={`${window.location.origin}/widget/paysimply/en/section/2571`}
            />
            <button id="create-widget-button" type="button" data-value="section" onClick={createWidget}>Section</button>
          </div>
          <div className="debug-widget">
            <input
              className="widget-debug-input"
              id="create-mobileapp-widget-textbox"
              defaultValue={`${window.location.origin}/widget/paysimply/en/section/2571?mobileapp`}
            />
            <button id="create-widget-button" type="button" data-value="mobileapp" onClick={createWidget}>Mobile App</button>
          </div>
        </>
      );
    }
    return null;
  }

  return (
    <div id="main-content" className="Home home-page">
      <div className="logo-box">
        <img className="paymentsource-image" src={paymentSource} alt="Payment Source" />
        <div className="languageDropdownContainer">
          <LanguageDropdown />
        </div>
      </div>
      <div>
        <h1 id="help-text">{t('ContactForm_General_Category_Label')}</h1>
      </div>
      <div id="home-mobile" className="mb-5">{renderMobileBrands()}</div>
      <div id="home-desktop">
        <table id="desktop-table" className="center" role="presentation">
          <tbody>{renderDesktopBrands()}</tbody>
        </table>
      </div>
      <div id="widget-debug-menu">
        {showWidgetDebug()}
      </div>
    </div>
  );
}

export default translate(Home);
